//
import Model from "@/models/Model"

//
import EmployeeModel from "@/models/HumanResource/HrEmployee"

/**
 * @class
 */
export default class GPosWorkstationUser extends Model {

    /**
     * { item_description }
     */
    type_names = {
        1: 'Sala',
        2: 'Terreno',
        3: 'Call center',
        4: 'Totem',
        5: 'Impresion Automatica',
    }

    /**
     * @description
     */
    static includes = [
        "hr_employee",
        "g_workstation_user_access_token.sl_ground_seller.hr_employee.g_user",
    ]

    /**
     * 
     */
    get g_workstation_user_access_token_g_user_id() {
        return this.getProperty('g_workstation_user_access_token.sl_ground_seller.hr_employee.g_user.id', '')
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get g_workstation_user_type_id() {
        return this.g_workstation_user_access_token.pos_workstation_type_id
    }

    /**
     * @description
     */
    get hr_employee_full_name () {
        return this.hr_employee.full_name
    }

    /**
     * @description
     */
    get hr_employee_rut () {
        return this.hr_employee.rut
    }
    
    /**
     * @description
     */
    get token_type () {
        return this.g_workstation_user_access_token.token_type
    }

    get type_name() {
        return this.type_names[this.g_workstation_user_type_id]
    }
    
    /**
     * @description
     */
    get g_workstation_user_url_token () {
        return this.g_workstation_user_access_token.url_token
    }

    /**
     * @description
     */
    reset () {

        // set includes models
        this.hr_employee = new EmployeeModel( this.hr_employee )
        this.names = this.hr_employee.names
        this.last_name1 = this.hr_employee.last_name1
        this.last_name2 = this.hr_employee.last_name2

        // set editable props
        this.g_branch_office_id         = this.hr_employee.g_branch_office_id
        // this.g_seller_user_id           = this.g_workstation_user_access_token.sl_ground_seller_id
        this.g_seller_user_id           = this.g_workstation_user_access_token_g_user_id
        this.pos_workstation_type_id    = this.g_workstation_user_access_token.pos_workstation_type_id

        // return reset model
        return this
    }

    /**
     * @description
     */
    resource () {
        return "g_pos_workstation_user"
    }

    /**
     * @description
     */
    toCreate () {

        //
        if (this.pos_workstation_type_id !== 2) {
            this.g_seller_user_id = undefined
        }

        //
        return this.clean([
            "g_branch_office_id",
            "g_seller_user_id",
            "pos_workstation_type_id",
        ])
    }
    
    /**
     * @description
     */
    toDelete () {

        //
        this.id = this.g_workstation_user_access_token.id

        //
        return this.clean([
            "id",
        ])
    }
    
    /**
     * @description
     */
    toUpdate () {

        //
        if (this.pos_workstation_type_id !== 2) {
            this.g_seller_user_id = undefined
        }

        //
        return this.clean([
            "g_branch_office_id",
            "g_seller_user_id",
            //"id",
            "names",
            "last_name1",
            "last_name2",
            "pos_workstation_type_id",
        ])
    }
}